
export default function Features() {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1E3A5F] mb-6">
            Esthétique & Fonctionnalité
          </h2>
          <div className="w-24 h-1 bg-[#A83232] mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Sté Reda et Naoual offre des solutions modernes alliant esthétique, robustesse et confort. Grâce à des matériaux premium et une conception soignée, nos réalisations sont durables, fiables et parfaitement adaptées aux besoins de chaque client.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300">
            <div className="w-16 h-16 flex items-center justify-center bg-[#A83232] rounded-full mb-6">
              <i className="ri-palette-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4">
              Design Moderne
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Nos créations allient esthétique contemporaine et élégance intemporelle, s'adaptant parfaitement à tous les styles architecturaux.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300">
            <div className="w-16 h-16 flex items-center justify-center bg-[#A83232] rounded-full mb-6">
              <i className="ri-shield-check-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4">
              Robustesse
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Utilisation de matériaux premium garantissant durabilité, sécurité et résistance exceptionnelle dans le temps.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300">
            <div className="w-16 h-16 flex items-center justify-center bg-[#A83232] rounded-full mb-6">
              <i className="ri-user-heart-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4">
              Confort
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Conception soignée offrant fonctionnalité optimale et expérience utilisateur exceptionnelle au quotidien.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
